export const VARIABLES = [
  { label: 'Código da Reserva', value: 'reservaCodigo', type: 'reservation' },
  { label: 'Data de Entrada', value: 'reservaDataEntrada', type: 'reservation' },
  { label: 'Horário de Entrada', value: 'reservaHorarioEntrada', type: 'reservation' },
  { label: 'Data de Saída', value: 'reservaDataSaida', type: 'reservation' },
  { label: 'Horário de Saída', value: 'reservaHorarioSaida', type: 'reservation' },
  { label: 'Status de Pagamento', value: 'reservaStatusPagamento', type: 'reservation' },
  { label: 'Status de Check-in', value: 'reservaStatusCheckin', type: 'reservation' },
  { label: 'Origem da Reserva', value: 'reservaOrigem', type: 'reservation' },
  { label: 'Data de Criação da Reserva', value: 'reservaDataCriacao', type: 'reservation' },
  { label: 'Valor da fatura / diárias', value: 'reservaValorFatura', type: 'reservation' },
  { label: 'Data de Criação do Check-in', value: 'checkinDataCriacao', type: 'check-in' },
  { label: 'Senha da Acomodação', value: 'checkinSenhaAcomodacao', type: 'check-in' },
  { label: 'Senha da Área de Acesso', value: 'checkinSenhaAreaAcesso', type: 'check-in' },
  { label: 'Link do check-in', value: 'checkinLink', type: 'links' },
  { label: 'Link do check-out', value: 'checkoutLink', type: 'links' },
  { label: 'Link do PDF do check-in', value: 'checkinLinkPDF', type: 'links' },
  { label: 'Link do contrato', value: 'linkContrato', type: 'links' },
  { label: 'Código da Acomodação', value: 'acomodacaoCodigo', type: 'accommodation' },
  { label: 'Nome da Acomodação', value: 'acomodacaoNome', type: 'accommodation' },
  { label: 'Localização da Acomodação', value: 'acomodacaoLocalizacao', type: 'accommodation' },
  { label: 'Tipo de Acesso da Acomodação', value: 'acomodacaoTipoAcesso', type: 'accommodation' },
  { label: 'Fechadura da Acomodação', value: 'acomodacaoFechadura', type: 'accommodation' },
  { label: 'Áreas de Acesso da Acomodação', value: 'acomodacaoAreasAcesso', type: 'accommodation' },
  { label: 'Acomodacao URL capa', value: 'acomodacaoURLCapa', type: 'accommodation' },
  { label: 'Nome da rede wi-fi', value: 'acomodacaoRedeWifi', type: 'accommodation' },
  { label: 'Senha da rede wi-fi', value: 'acomodacaoSenhaWifi', type: 'accommodation' },
  { label: 'Mais informações', value: 'acomodacaoMaisInfo', type: 'accommodation' },
  { label: 'Primeiro nome do hóspede titular', value: 'hospedePrimeiroNomeTitular', type: 'guest' },
  { label: 'Nome do hóspede titular', value: 'hospedeNomeTitular', type: 'guest' },
  { label: 'E-mail do hóspede titular', value: 'hospedeEmailTitular', type: 'guest' },
  { label: 'CPF do hóspede titular', value: 'hospedeCPFTitular', type: 'guest' },
  { label: 'Passaporte do hóspede titular', value: 'hospedePassaporteTitular', type: 'guest' },
  { label: 'Telefone do hóspede titular', value: 'hospedeTelefoneTitular', type: 'guest' },
  { label: 'Todos os dados dos hóspedes', value: 'hospedeTodos', type: 'guest' },
  { label: 'Data de hoje', value: 'hoje', type: 'general' },
  { label: 'Dia atual', value: 'diaAtual', type: 'general' },
  { label: 'Dia atual por extenso', value: 'diaAtualExtenso', type: 'general' },
  { label: 'Mês atual', value: 'mesAtual', type: 'general' },
  { label: 'Mês atual por extenso', value: 'mesAtualExtenso', type: 'general' },
  { label: 'Ano atual', value: 'anoAtual', type: 'general' },
  { label: 'Ano atual por extenso', value: 'anoAtualExtenso', type: 'general' },
  { label: 'Empresa razão sócial atual', value: 'empresaRazaoSocial', type: 'business' },
  { label: 'Empresa nome fantasia', value: 'empresaNomeFantasia', type: 'business' },
  { label: 'Empresa CNPJ', value: 'empresaCNPJ', type: 'business' },
  { label: 'Empresa email', value: 'empresaEmail', type: 'business' },
  { label: 'Empresa telefone', value: 'empresaTelefone', type: 'business' },
  { label: 'Empresa endereço', value: 'empresaEndereco', type: 'business' },
]

export const ICONS_MAPPER: any = {
  reservation: '🏨',
  accommodation: '🏠',
  'check-in': '🔑',
  guest: '🧑',
  general: '📅',
  links: '🔗',
  business: '🏢',
}